import { SectionLoader, Spacer } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import React, { PropsWithChildren } from 'react';
import { useProducts } from '../../../data-access';
import ModifierQueryForm from './ModifierQueryForm';

const ModifierQuery: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoadedLookups, isLoadingLookups } = useProducts();

  if (isLoadingLookups && !isLoadedLookups) {
    return <SectionLoader isLoading title={'Fetching rebates...'} />;
  }

  return (
    <Box
      component={'form'}
      autoComplete="off"
      sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%' }}
    >
      <ModifierQueryForm />
      {children}
      <Spacer height="2rem" />
    </Box>
  );
};

export default ModifierQuery;
